export const PLAYER_SELECTION_STORAGE_KEY = "skyview.player.selection";

export type PlayerSelection = {
  streamIds: string[];
  activeStreamId: string | null;
};

export const parsePlayerSelection = (value: unknown): PlayerSelection | null => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const { streamIds, activeStreamId } = value as Record<string, unknown>;
  if (!Array.isArray(streamIds)) return null;

  const ids = [...new Set(streamIds.filter((id): id is string =>
    typeof id === "string" && id.trim().length > 0,
  ))];
  return {
    streamIds: ids,
    activeStreamId: typeof activeStreamId === "string" && ids.includes(activeStreamId)
      ? activeStreamId
      : ids[0] ?? null,
  };
};

export const reconcilePlayerSelection = (
  selection: PlayerSelection,
  availableIds: ReadonlySet<string>,
): PlayerSelection => {
  const streamIds = selection.streamIds.filter((id) => availableIds.has(id));
  return {
    streamIds,
    activeStreamId: selection.activeStreamId && streamIds.includes(selection.activeStreamId)
      ? selection.activeStreamId
      : streamIds[0] ?? null,
  };
};

export const readPlayerSelection = (): PlayerSelection | null => {
  try {
    const raw = window.localStorage.getItem(PLAYER_SELECTION_STORAGE_KEY);
    return raw === null ? null : parsePlayerSelection(JSON.parse(raw));
  } catch {
    return null;
  }
};

export const persistPlayerSelection = (selection: PlayerSelection): void => {
  try {
    window.localStorage.setItem(PLAYER_SELECTION_STORAGE_KEY, JSON.stringify(selection));
  } catch {
    // Player selection remains usable when browser storage is unavailable.
  }
};
